import React from "react";
import { useTraceabilityData } from "./contexts/TraceabilityDataContext";
import { Link } from "react-router-dom";

import "./App.css";
import "./css/style.css";
import "./css/bootstrap.css";

const MilkGrading = () => {
    const { brandData, loading, errors } = useTraceabilityData();
    const brandName = brandData?.logo?.brandName || "[Brand Name]";

    const { dairyFarmMessage } = useTraceabilityData()
    const milkCollected = dairyFarmMessage?.amountOfMilkCollected

    return (

        <div className="">

            <div className="wrapper2">
                <h2 className="heading2">Milk Grading</h2>
            </div>

            <section className="py-0">
                <div className="container py-0">
                    {/* more blogs */}
                    <div className="row g-3">
                        <div className="col-lg-4 col-12">
                            <a>
                                <div className="product-item col">
                                    <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                                        <img src="img/mg-header.png" alt="" className="card-img-top" />
                                        <div className="position-absolute text-overlay text-white p-3">
                                            <h1 className="fw-bold opacity-50" style={{ fontSize: "4rem" }}>02</h1>
                                        </div>
                                    </div>
                                </div>
                            </a>

                            <p className="card-text text-muted py-3 px-2">
                                {loading.brand && "Loading brand information..."}
                                {!loading.brand && errors.brand && "Error loading brand information."}
                                {!loading.brand && !errors.brand && (
                                    <>
                                        At {brandName}, we combine precision and fairness in milk grading. Every batch undergoes rigorous quality checks, with pricing based on quality and quantity. Farmer-run centers and instant digital payments ensure transparency while boosting local economies. This batch, {milkCollected} liters passed our stringent testing, delivering excellence at every step.
                                    </>
                                )}
                            </p>
                            <div className="underline2"></div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="bg-light">
                <div className="container p-3">
                    <h6 className="card-title fw-bold my-2">Milk Grading Insights</h6>

                    <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-2 row-cols-2 g-3">

                        <Link to="/technology-driven-quality-tests">
                            <div className="product-item col">
                                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                                    <img src="img/Asset-45.png" alt="" className="card-img-top" />
                                    <div className="position-absolute text-overlay-f text-white p-3">
                                        <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                                            Technology-Driven<br /> Quality Checks
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </Link>

                        <Link to="/empowering-farmers-and-communities">
                            <div className="product-item col">
                                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                                    <img src="img/Asset-46.png" alt="" className="card-img-top" />
                                    <div className="position-absolute text-overlay-f text-white p-3">
                                        <h6 className="fw-normal" style={{ fontSize: "14px" }}>
                                            Empowering Farmers & Communities
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </Link>

                        <Link to="/sustainability-in-milk-grading">
                            <div className="product-item col">
                                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                                    <img src="img/Asset-47.png" alt="" className="card-img-top" />
                                    <div className="position-absolute text-overlay-f text-white p-3">
                                        <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                                            Sustainability in Milk Grading
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </Link>

                        <Link to="/cloud-connectivity">
                            <div className="product-item col">
                                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                                    <img src="img/Asset-48.png" alt="" className="card-img-top" />
                                    <div className="position-absolute text-overlay-f text-white p-3" style={{ top: "30%" }}>
                                        <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                                            Cloud Connectivity
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>

            <div className="flex justify-between mt-10 px-4 mb-4 gap-10 sm:px-0">
                <Link
                    to="/smart-farming"
                    className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
                >
                    Previous
                </Link>
                <Link
                    to="/technology-driven-quality-tests"
                    className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
                >
                    Next
                </Link>

            </div>
        </div>


    );
};

export default MilkGrading;
